export default function RaEdit(theme): object {
  return {
    RaEdit: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.paper,
          borderRadius: theme.spacing(2),
          boxShadow: theme.shadows[2],
          '& .RaEdit-noActions': {
            marginTop: 0,
          },
        },
      },
    },
  }
}
